import $ from 'jquery';

/**
 * data-{name}="{value}":
 *
 * .dynamic-fixed_wrapper
 *    [data-breakpoint="575"] Window width when activate component
 *
 * .dynamic-fixed_element
 *    [data-offset="0"] Pixels to wait until scrolled out
 */
export default class DynamicFixed {
  constructor() {
    const $wrappers = $('.dynamic-fixed_wrapper');
    const $window = $(window);
    const $body = $('body');

    // Skipping if none found
    if (!$wrappers.length) {
      return;
    }

    // Decides if element has to be fixed
    const handleActivation = () => {
      $wrappers.each(function () {
        const $wrapper = $(this);
        const $element = $wrapper.first('.dynamic-fixed_element');

        if ($element.length) {
          const { clientHeight: height } = $element[0];
          const scrolled = $window.scrollTop() > height + $wrapper.offset().top + ($element.data('offset') || 0);

          if ($wrapper.data('enabled') && scrolled) {
            $wrapper.css('height', `${height}px`);
            $wrapper.addClass('fixed');
          } else {
            $wrapper.css('height', 'auto');
            $wrapper.removeClass('fixed');
          }
        }
      });
    };

    // Decides if component is enabled
    const handleDimensions = () => {
      $wrappers.each(function () {
        const $wrapper = $(this);
        const width = $wrapper.data('breakpoint') || 575;
        $wrapper.data('enabled', $window.width() > width);
      });
      handleActivation();
    };

    // Action
    ($body.hasClass('v2-body') || $body.hasClass('mm-wrapper') ? $body : $window).scroll(handleActivation);
    $window.resize(handleDimensions);
    handleDimensions();
  }
}



// WEBPACK FOOTER //
// ./vively/scripts/components/dynamic_fixed.js